module.exports = __webpack_public_path__ + "img/frank_frazetta_serpent-grapple.81b3c63d.jpg";